import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import FacilitiesManagementSrv from './FacilitiesManagementSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.facilitiesManagement)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return FacilitiesManagementSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}

export function addAsync(model) {
  return function() {
    return FacilitiesManagementSrv.add(model);
  };
}

export function updateAsync(model) {
  return function() {
    return FacilitiesManagementSrv.update(model);
  };
}
